import { Component, Input } from '@angular/core';
import { AbstractFormFieldComponent } from '@shared/form-fields/abstract-form-field/abstract-form-field.component';
import { makeProvider } from '@shared/form-fields/make-provider';

@Component({
    selector: 'app-input-slide-toggle',
    styleUrls: ['./slide-toggle-input.component.scss'],
    template: `
        <cll-slide-toggle size="medium"
                          colour="secondary"
                          [(ngModel)]="value"
                          [name]="name"
                          [disabled]="disabled"
                          [ngModelOptions]="{ standalone: true }"
                          (click)="$event.stopImmediatePropagation()">
            {{ _message || label }}
        </cll-slide-toggle>

        <cll-form-field-hint *ngIf="_hint">{{ _hint }}</cll-form-field-hint>
        <cll-form-field-error *ngFor="let message of errorMessages">{{ message }}</cll-form-field-error>
`,
    providers: [makeProvider(SlideToggleInputComponent)],
})
export class SlideToggleInputComponent extends AbstractFormFieldComponent<boolean> {
    @Input() message: string;
    @Input() messageTrue: string;
    @Input() messageFalse: string;
    @Input() hintTrue: string;
    @Input() hintFalse: string;
    @Input() label: string;

    get _message(): string {
        if (this.value) {
            return this.messageTrue || this.message;
        }

        return this.messageFalse || this.message;
    }

    get _hint(): string {
        if (this.value) {
            return this.hintTrue || this.hint;
        }

        return this.hintFalse || this.hint;
    }
}
